import styled from 'styled-components';
import BasicSelect from '../form/BasicSelect';
import sharedStyles from '../styles';
import breakpoints from '../breakpoints';
import IconArrow from '../images/chevron-down.svg';

const SelectSearch = styled(BasicSelect)`
  background-image: url(${IconArrow});
  background-position: 93% 54%;
  background-size: ${sharedStyles.spacing['spacing-md']};
  padding: 0 ${sharedStyles.spacing['spacing-lg']} 0
    ${sharedStyles.spacing['spacing-md']};
  height: 40px;
  border: 0;
  width: 50%;
  border-left: 1px solid ${({ theme }) => theme?.colors?.border};
  border-radius: 0;
  font-weight: ${sharedStyles.fontWeight.light};
  font-size: ${sharedStyles.fontSize.base};

  @media screen and (min-width: ${breakpoints.md}) {
    width: 200px;
    border: 1px solid ${({ theme }) => theme?.colors?.border};
  }
`;

export default SelectSearch;
